import React, { useState } from "react";
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds,    MobileUnderCalAds } from "../../Ads";
import { CalculatorsType } from '../ConstantsEN';
import SharedHelmet from "../Helmet";
const TITLE = 'Electronic Carbohydrate Calculator - Learn How to Calculate Carbohydrates';
const DESCRIPTION = 'The carbohydrate calculator helps you maintain, lose, or gain weight. The carbohydrate calculator is a valuable tool that helps individuals determine the optimal amount of carbohydrates to consume daily.';
const KEYWORDS = 'Carbohydrates, Carbohydrate Calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/carbohydrate/';
function CarbohydrateCalculator() {
    const [age, setAge] = useState("");
    const [gender] = useState("male");
    const [height, setHeight] = useState("");
    const [weight, setWeight] = useState("");
    const [activity, setActivity] = useState("");
    const [result, setResult] = useState(null);
    const calculateCarbohydrates = () => {
        const genderFactor = gender === "male" ? 5 : -161;
        const calories = Math.round(
            10 * weight + 6.25 * height - 5 * age + genderFactor
        );
        const activityFactors = {
            sedentary: 1.2,
            lightlyActive: 1.375,
            moderatelyActive: 1.55,
            active: 1.725,
            veryActive: 1.9,
        };
        const tdee = calories * activityFactors[activity];
        const tdee_lose_0_5 = calories * activityFactors[activity] - 500;
        const tdee_lose_1 = calories * activityFactors[activity] - 1000;
        const tdee_gain_0_5 = calories * activityFactors[activity] + 500;
        const tdee_gain_1 = calories * activityFactors[activity] + 1000;
        const carbs40 = Math.round((tdee * 0.4) / 3.75);
        const carbs55 = Math.round((tdee * 0.55) / 3.75);
        const carbs65 = Math.round((tdee * 0.65) / 3.75);
        const carbs75 = Math.round((tdee * 0.75) / 3.75);
        const carbs40Lose0_5 = Math.round((tdee_lose_0_5 * 0.4) / 3.75);
        const carbs55Lose0_5 = Math.round((tdee_lose_0_5 * 0.55) / 3.75);
        const carbs65Lose0_5 = Math.round((tdee_lose_0_5 * 0.65) / 3.75);
        const carbs75Lose0_5 = Math.round((tdee_lose_0_5 * 0.75) / 3.75);
        const carbs40Lose1 = Math.round((tdee_lose_1 * 0.4) / 3.75);
        const carbs55Lose1 = Math.round((tdee_lose_1 * 0.55) / 3.75);
        const carbs65Lose1 = Math.round((tdee_lose_1 * 0.65) / 3.75);
        const carbs75Lose1 = Math.round((tdee_lose_1 * 0.75) / 3.75);
        const carbs40Gain0_5 = Math.round((tdee_gain_0_5 * 0.4) / 3.75);
        const carbs55Gain0_5 = Math.round((tdee_gain_0_5 * 0.55) / 3.75);
        const carbs65Gain0_5 = Math.round((tdee_gain_0_5 * 0.65) / 3.75);
        const carbs75Gain0_5 = Math.round((tdee_gain_0_5 * 0.75) / 3.75);
        const carbs40Gain1 = Math.round((tdee_gain_1 * 0.4) / 3.75);
        const carbs55Gain1 = Math.round((tdee_gain_1 * 0.55) / 3.75);
        const carbs65Gain1 = Math.round((tdee_gain_1 * 0.65) / 3.75);
        const carbs75Gain1 = Math.round((tdee_gain_1 * 0.75) / 3.75);
        return {
            goal: "Weight Maintenance",
            calories: tdee,
            carbs40,
            carbs55,
            carbs65,
            carbs75,
            carbs40Lose0_5,
            carbs55Lose0_5,
            carbs65Lose0_5,
            carbs75Lose0_5,
            carbs40Lose1,
            carbs55Lose1,
            carbs65Lose1,
            carbs75Lose1,
            carbs40Gain0_5,
            carbs55Gain0_5,
            carbs65Gain0_5,
            carbs75Gain0_5,
            carbs40Gain1,
            carbs55Gain1,
            carbs65Gain1,
            carbs75Gain1,
            tdee_lose_0_5,
            tdee_lose_1,
            tdee_gain_0_5,
            tdee_gain_1
        };
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const result = calculateCarbohydrates();
        setResult(result);
    };
    return (
        <div>
  <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '32px' }}>
                        <h1 style={{ fontSize: '16px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <p>
                                            The carbohydrate calculator helps you maintain, lose, or gain weight.
                                            The carbohydrate calculator is a valuable tool that helps individuals determine the optimal amount of carbohydrates to consume daily.
                                            Carbohydrates are an important source of energy in the diet and play a major role in meeting daily body needs.
                                            If carbohydrates are consumed properly, they can help maintain energy levels and physical performance.
                                        </p>
                                        <hr />
                                    </div>
                                    <br />
                                </div>
                                <MobileUnderCalAds />
                                <div className="row">
                                    <div className="col-sm-12 col-md-5 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            Carbohydrate Calculator
                                        </div>
                                        <hr />
                                        <br />
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group d-flex align-items-center">
                                                <b>
                                                    <label htmlFor='height' className="form-label ms-2">Height</label>
                                                </b>
                                                <input
                                                    type="number"
                                                    id="weightNumber"
                                                    value={height}
                                                    onChange={(e) => setHeight(e.target.value)}
                                                    className="form-control ml-2"
                                                    style={{ width: '75px' }}
                                                    placeholder="175"
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">cm</span>
                                                </div>
                                            </div>
                                            <br />
                                            <div className="form-group d-flex align-items-center">
                                                <b>
                                                    <label htmlFor='weightNumber' className="form-label ms-2">Weight</label>
                                                </b>
                                                <input
                                                    type="number"
                                                    id="weightNumber"
                                                    value={weight}
                                                    onChange={(e) => setWeight(e.target.value)}
                                                    className="form-control ml-2"
                                                    style={{ width: '75px' }}
                                                    placeholder="65"
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">kg</span>
                                                </div>
                                            </div>
                                            <br />
                                            <div className="form-group d-flex align-items-center">
                                                <b>
                                                    <label htmlFor='age' className="form-label ms-2">Age</label>
                                                </b>
                                                <input
                                                    type="number"
                                                    id="age"
                                                    value={age}
                                                    onChange={(e) => setAge(e.target.value)}
                                                    className="form-control"
                                                    style={{ width: '75px' }}
                                                    placeholder="6"
                                                />
                                            </div>
                                            <br />
                                            <div>
                                                <b>
                                                    <label  htmlFor="activitySelec" className="form-label ms-2">Activity Level</label>
                                                </b>
                                                <select
                                                id="activitySelec"
                                                    className="form-select"
                                                    value={activity}
                                                    onChange={(e) => setActivity(e.target.value)}
                                                >
                                                    <option value="">-- Select Activity --</option>
                                                    <option value="sedentary">Sedentary: Very little physical activity or no exercise</option>
                                                    <option value="lightlyActive">Lightly Active: Light exercise or physical activity 1-3 days a week</option>
                                                    <option value="moderatelyActive">Moderately Active: Moderate exercise or physical activity 3-5 days a week</option>
                                                    <option value="active">Active: Intense exercise or physical activity 6-7 days a week</option>
                                                    <option value="veryActive">Very Active: Very intense exercise or daily vigorous physical activity</option>
                                                </select>
                                            </div>
                                            <br />
                                            <hr />
                                            <button type="submit" className="btn btn-success" style={{ fontSize: '20px' }}>
                                                Calculate
                                            </button>
                                        </form>
                                    </div>
                                    <div className="col-sm-12 col-md-7">
                                        {result && (
                                          <table >
                                                <thead>
                                                    <tr>
                                                        <th >Goal</th>
                                                        <th >Daily Calories</th>
                                                        <th >40%</th>
                                                        <th >55%</th>
                                                        <th >65%</th>
                                                        <th >75%</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Maintain Weight</td>
                                                        <td>{result.calories} calories</td>
                                                        <td>{result.carbs40} g</td>
                                                        <td>{result.carbs55} g</td>
                                                        <td>{result.carbs65} g</td>
                                                        <td>{result.carbs75} g</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Lose 0.5 kg/week</td>
                                                        <td>{result.tdee_lose_0_5} calories</td>
                                                        <td>{result.carbs40Lose0_5} g</td>
                                                        <td>{result.carbs55Lose0_5} g</td>
                                                        <td>{result.carbs65Lose0_5} g</td>
                                                        <td>{result.carbs75Lose0_5} g</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Lose 1 kg/week</td>
                                                        <td>{result.tdee_lose_1} calories</td>
                                                        <td>{result.carbs40Lose1} g</td>
                                                        <td>{result.carbs55Lose1} g</td>
                                                        <td>{result.carbs65Lose1} g</td>
                                                        <td>{result.carbs75Lose1} g</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Gain 0.5 kg/week</td>
                                                        <td>{result.tdee_gain_0_5} calories</td>
                                                        <td>{result.carbs40Gain0_5} g</td>
                                                        <td>{result.carbs55Gain0_5} g</td>
                                                        <td>{result.carbs65Gain0_5} g</td>
                                                        <td>{result.carbs75Gain0_5} g</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Gain 1 kg/week</td>
                                                        <td>{result.tdee_gain_1} calories</td>
                                                        <td>{result.carbs40Gain1} g</td>
                                                        <td>{result.carbs55Gain1} g</td>
                                                        <td>{result.carbs65Gain1} g</td>
                                                        <td>{result.carbs75Gain1} g</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                                                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.healthCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">All You Need to Know About Carbohydrates: How to Calculate Them and Their Importance in Your Diet:</div>
                            <div className="info-section-body">
                                <u><h2 style={{ fontSize: '16px' }}> All You Need to Know About Carbohydrates: How to Calculate Them and Their Importance in Your Diet
                                </h2> </u> <br />
                                <p>
                                    Carbohydrates are one of the fundamental components of food, playing a crucial role in providing the body with energy and maintaining its vital functions. In this article, we will explore the world of carbohydrates and learn how to calculate them accurately and understand their importance in your diet.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>
                                    Understanding Carbohydrates
                                </h2> </u> <br />
                                <p>
                                    Carbohydrates are chemical compounds composed of carbon, hydrogen, and oxygen. They include sugars, starches, and fiber and are found in various foods such as bread, rice, fruits, and vegetables.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}> How to Calculate Carbohydrates </h2> </u> <br />
                                <p>
                                    There is a growing need to determine the amount of carbohydrates you should consume daily to achieve a healthy balance in your diet. Carbohydrates can be calculated by tracking nutritional labels on packaging and using online carbohydrate calculators.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}> The Importance of Carbohydrates in Nutrition:
                                </h2> </u> <br />
                                <p>
                                    In short, carbohydrates are a fundamental part of your diet and are highly important for your overall health and daily performance. By understanding how to calculate and incorporate them properly into your meals, you can enjoy their benefits more effectively and live a healthy life.
                                </p>
                                <hr />
                            </div>
                        </div>
                    </div>
                    <br />
                    <u>  <h2>Frequently Asked Questions</h2>
                    </u>
                    <br />
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Many Carbohydrates Should You Consume?</h3>
                            </div>
                            <div className="info-section-body">
                                Several factors affect the amount of carbohydrates you need, including individual factors, exercise intensity, and duration. However, for athletes, a general guideline is that 60-70% of your energy should come from carbohydrates. High-intensity exercises lasting around 1-3 hours require approximately 6-10 grams of carbohydrates per kilogram of body weight, compared to low-intensity exercises that only need 3-5 grams per kilogram of body weight. Carbohydrate intake depends on the type, intensity, and duration of exercise, with higher intensity exercise requiring more carbohydrates. Trainers and planning can be very helpful in determining the amount of carbohydrates you need during your workout, as depleting carbohydrates will lead to using the body's fat and protein stores as fuel, which could result in muscle burning as fuel instead of food.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Do Carbohydrates Affect Muscle Growth?</h3>
                            </div>
                            <div className="info-section-body">
                                Some people believe that to build muscle quickly, you should sacrifice carbohydrates to burn fat as fuel and rely on protein to assist in muscle growth. This is true when athletes are trying to lean out for a short period, but for most of the year, when trying to build muscle and promote growth, a moderate to high carbohydrate diet is the preferred approach. Higher energy levels, increased muscle support, faster recovery rates, and muscle breakdown prevention are all guaranteed benefits when consuming carbohydrates. Contrary to common belief, carbohydrates can help your muscles grow stronger, and they should definitely be included in your diet.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What Happens When You Consume All Carbohydrates?</h3>
                            </div>
                            <div className="info-section-body">
                                Your performance drops initially when you either exceed or consume all carbohydrates, and muscle movements and stimulation become more challenging, affecting your overall performance. When carbohydrate stores are used up, the body turns to protein as a source of energy, which later affects its ability to gain and support muscle. Burning protein as energy can cause more problems, as when your body tries to eliminate by-products of protein, the kidneys must work harder, leading to stress that could damage them in the long run. Carbohydrates also help nourish the brain and central nervous system, and when you run out of carbohydrates, it can affect their performance and, in severe cases, lead to more problems.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CarbohydrateCalculator;
